import { create } from 'zustand';
import type { Brand } from '@/types';

interface AppState {
  // Sidebar
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  toggleSidebar: () => void;

  // Brands cache
  brands: Brand[];
  setBrands: (brands: Brand[]) => void;

  // Current filter selections
  selectedBrandId: string | null;
  setSelectedBrandId: (id: string | null) => void;

  // Mobile mode detection
  isMobile: boolean;
  setIsMobile: (mobile: boolean) => void;
}

export const useAppStore = create<AppState>((set) => ({
  // Sidebar - default closed on mobile (< 1024px)
  sidebarOpen: typeof window !== 'undefined' ? window.innerWidth >= 1024 : true,
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),

  // Brands
  brands: [],
  setBrands: (brands) => set({ brands }),

  // Filters
  selectedBrandId: null,
  setSelectedBrandId: (id) => set({ selectedBrandId: id }),

  // Mobile - detect on init
  isMobile: typeof window !== 'undefined' ? window.innerWidth < 1024 : false,
  setIsMobile: (mobile) => set({ isMobile: mobile }),
}));

export default useAppStore;
